module.exports = __webpack_public_path__ + "media/icons/gavel-b9c3a7cf.png";